// import { AnimatePresence, motion } from "framer-motion";
// import { useEffect, useState } from "react";
// import axios from "axios";
// import { parse } from "tldts";
// import "../css/Hero.css";
// import h1 from "../assets/g5.jpeg";
// import h2 from "../assets/innner.jpeg";

// export default function Hero() {
//   const [company, setCompany] = useState({
//     name: "Your Bank",
//     logo: null,
//     favicon: null,
//     domain: "",
//     subdomain: "",
//   });
//   const [slides, setSlides] = useState([]);
//   const [bankNews, setBankNews] = useState([]);
//   const [index, setIndex] = useState(0);
//   const [fetchError, setFetchError] = useState("");

//   const getDomainInfo = () => {
//     const hostname = window.location.hostname;
//     const parsed = parse(hostname);
//     return {
//       domain: parsed.domainWithoutSuffix || "",
//       subdomain: parsed.subdomain || "",
//     };
//   };

//   useEffect(() => {
//     const fetchCompany = async () => {
//       try {
//         const { domain } = getDomainInfo();
//         const response = await axios.get("https://payyug.in/api/get-company", {
//           params: { domain },
//         });

//         const data = response.data;

//         if (data && Object.keys(data).length > 0) {
//           setCompany((prev) => ({
//             ...prev,
//             name: data.name || prev.name,
//             logo: data.logo || prev.logo,
//             favicon: data.favicon || prev.favicon,
//             domain: data.domain || prev.domain,
//             subdomain: data.subdomain || prev.subdomain,
//           }));

//           // Add favicon dynamically
//           if (data.favicon) {
//             const link =
//               document.querySelector("link[rel*='icon']") ||
//               document.createElement("link");
//             link.type = "image/png";
//             link.rel = "icon";
//             link.href = `https://payyug.in/${data.favicon.startsWith("images/") ? data.favicon.slice(7) : data.favicon}`;
//             document.head.appendChild(link);
//           }
//         } else {
//           setFetchError("Company info not found.");
//         }
//       } catch (err) {
//         console.error("Company fetch failed:", err);
//         setFetchError("Failed to fetch company info.");
//       }
//     };

//     fetchCompany();
//   }, []);

//   // Slides and news
//   useEffect(() => {
//     setSlides([
//       {
//         id: 1,
//         img: h1,
//         title: company.name ? `Welcome to ${company.name}` : "Banking Made Easy",
//         desc: "Experience seamless online banking with secure transactions, anytime, anywhere.",

//       },
//       {
//         id: 2,
//         img: h2,
//         title: company.name
//           ? `${company.name} - Your Trusted Financial Partner`
//           : "Your Trusted Financial Partner",
//         desc: "Grow your wealth with smart investments, loans.",
//         btn: "Explore Services",
//       },
//     ]);

//     setBankNews([
//       "RBI increases repo rate by 0.25%.",
//       "New digital banking guidelines announced.",
//       "Government launches financial literacy drive.",
//     ]);
//   }, [company]);

//   useEffect(() => {
//     if (!slides.length) return;
//     const timer = setInterval(() => setIndex((prev) => (prev + 1) % slides.length), 8000);
//     return () => clearInterval(timer);
//   }, [slides]);

//   return (
//     <div className="hero-wrapper">
//       {fetchError && <div className="hero-error">{fetchError}</div>}

//       <AnimatePresence mode="wait">
//         {slides.length > 0 && (
//           <motion.div
//             key={slides[index].id}
//             className="hero-slide"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             transition={{ duration: 1 }}
//           >
//             <div className="hero-bg" style={{ backgroundImage: `url(${slides[index].img})` }} />
//             <div className="hero-overlay" />
//             <div className="hero-content">
//               <motion.div
//                 className="hero-text-box"
//                 initial={{ y: 40, opacity: 0 }}
//                 animate={{ y: 0, opacity: 1 }}
//                 transition={{ delay: 0.3 }}
//               >
//                 <h1>{slides[index].title}</h1>
//                 <p>{slides[index].desc}</p>

//               </motion.div>

//               <div className="hero-figure">
//                 <img src={slides[index].img} alt={slides[index].title} />
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Dots */}
//       <div className="hero-dots">
//         {slides.map((_, i) => (
//           <span
//             key={i}
//             className={`hero-dot ${i === index ? "active" : ""}`}
//             onClick={() => setIndex(i)}
//           />
//         ))}
//       </div>

//       {/* News Ticker
//       <div className="hero-news">
//         <div className="ticker">
//           <div className="ticker-content">
//             {bankNews.concat(bankNews).map((n, i) => (
//               <span key={i} className="news-item">
//                 {n}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//  */}

//     </div>
//   );
// }



import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { parse } from "tldts";
import "../css/Hero.css";

const AutoTypingTitle = ({
  text,
  typingSpeed = 150,
  erasingSpeed = 100,
  pauseTime = 2000,
}) => {
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (!text) return;

    let timer;
    const handleTyping = () => {
      if (!isDeleting) {
        if (charIndex < text.length) {
          setDisplayText(text.substring(0, charIndex + 1));
          setCharIndex((prev) => prev + 1);
          timer = setTimeout(handleTyping, typingSpeed);
        } else {
          timer = setTimeout(() => setIsDeleting(true), pauseTime);
        }
      } else {
        if (charIndex > 0) {
          setDisplayText(text.substring(0, charIndex - 1));
          setCharIndex((prev) => prev - 1);
          timer = setTimeout(handleTyping, erasingSpeed);
        } else {
          setIsDeleting(false);
        }
      }
    };

    timer = setTimeout(handleTyping, isDeleting ? erasingSpeed : typingSpeed);
    return () => clearTimeout(timer);
  }, [text, charIndex, isDeleting, typingSpeed, erasingSpeed, pauseTime]);

  return (
    <h1 className="landing-home-main-title landing-home-green">
      <span className="typing-text">
        {displayText}
        <motion.span
          animate={{ opacity: [0, 1, 0] }}
          transition={{ repeat: Infinity, duration: 0.8 }}
          className="landing-home-cursor"
        >
          |
        </motion.span>
      </span>
    </h1>
  );
};

const wavePaths = [
  "M0,160L48,176C96,192,192,224,288,224C384,224,480,192,576,165.3C672,139,768,117,864,128C960,139,1056,181,1152,197.3C1248,213,1344,203,1392,197.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
  "M0,192L48,213.3C96,235,192,277,288,266.7C384,256,480,192,576,160C672,128,768,128,864,149.3C960,171,1056,213,1152,202.7C1248,192,1344,128,1392,96L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
  "M0,128L48,144C96,160,192,192,288,181.3C384,171,480,117,576,101.3C672,85,768,107,864,138.7C960,171,1056,213,1152,213.3C1248,213,1344,171,1392,149.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
];

const Hero = () => {
  const navigate = useNavigate();
  const [company, setCompany] = useState({
    name: "Your Bank",
    logo: null,
    favicon: null,
    domain: "",
    subdomain: "",
    superAdminId:"",
  });

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  const notCompanyLogo = "https://cdn-icons-png.flaticon.com/512/2830/2830284.png";

  // URL Cleaning Helper (Same as Navbar)
  const getImageUrl = (path) => {
    if (!path) return notCompanyLogo;
    const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
    return `https://payyug.in/${cleanPath}`;
  };

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { domain } = getDomainInfo();
        const response = await axios.get("https://payyug.in/api/get-company", { params: { domain } });
        const data = response.data;

        if (data && Object.keys(data).length > 0) {
          setCompany((prev) => ({
            ...prev,
            name: data.name || prev.name,
            logo: data.logo || prev.logo,
            favicon: data.favicon || prev.favicon,
            domain: data.domain || prev.domain,
            subdomain: data.subdomain || prev.subdomain,
            superAdminId: data.superAdminId || prev.superAdminId,
          }));

          // Favicon update logic
          if (data.favicon) {
            const cleanFav = data.favicon.startsWith("images/") ? data.favicon.slice(7) : data.favicon;
            const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
            link.type = "image/png";
            link.rel = "icon";
            link.href = `https://payyug.in/${cleanFav}`;
            document.head.appendChild(link);
          }
        }
      } catch (err) {
        console.error("Company fetch failed:", err);
      }
    };

    fetchCompany();
  }, []);

  const getWaveTransition = (duration) => ({
    duration: duration,
    repeat: Infinity,
    repeatType: "mirror",
    ease: "easeInOut",
  });

  return (
    <div className="landing-home-hero">
      <div className="landing-home-hero-left">
        <div className="landing-home-animation-container">
          <motion.div
            className="landing-home-spiro-wrapper"
            animate={{ rotate: 360 }}
            transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
          >
            {[...Array(20)].map((_, i) => (
              <div
                key={i}
                className="landing-home-flower-petal"
                style={{ transform: `rotate(${i * 18}deg) translateX(40px)` }}
              />
            ))}
          </motion.div>

          <div className="landing-home-center-logo">
            <div className="landing-home-logo-inner">
              <img
                src={getImageUrl(company.logo)} // Use Helper here
                alt={company.name}
                className="landing-home-logo-img"
                onError={(e) => { e.target.src = notCompanyLogo; }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="landing-home-hero-right">
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="landing-home-content-box"
        >
          {/* Typing Title with Dynamic Name */}
          <AutoTypingTitle
            text={company.name}
            typingSpeed={150}
            erasingSpeed={80}
            pauseTime={1500}
          />

          <h3 className="landing-home-title">
            <span className="landing-home-navy">
              Empowering Financial Growth for a Stronger Bharat
            </span>
          </h3>
          <p className="landing-home-desc">
            At <strong>{company.name}</strong>, we bridge the
            gap between aspirations and achievements. Providing seamless
            micro-financial solutions.
          </p>

          <motion.button
            className="landing-home-cta-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate("/service")}
          >
            Explore Services &nbsp; →
          </motion.button>
        </motion.div>
      </div>

      <div className="landing-home-patti-container">
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none" className="landing-home-patti-svg">
          <motion.path
            fill="#1a237e"
            fillOpacity="0.4"
            animate={{ d: wavePaths }}
            transition={getWaveTransition(4)}
          />
          <motion.path
            fill="#28a745"
            fillOpacity="0.6"
            animate={{ d: [wavePaths[1], wavePaths[2], wavePaths[0]] }}
            transition={getWaveTransition(3)}
          />
          <motion.path
            fill="#28a745"
            fillOpacity="1"
            animate={{ d: [wavePaths[2], wavePaths[0], wavePaths[1]] }}
            transition={getWaveTransition(2.5)}
          />
        </svg>
      </div>
    </div>
  );
};

export default Hero;